import './ProstayReview.css';
import WhyChooseOurPms from '../components/WhyChooseOurPms';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import useLanguagePrefix from '../LanguagePrefix';

function ProstayReview() {
    const { t } = useTranslation();
    const langPrefix = useLanguagePrefix();

    return (
        <div>
            <Helmet>
                <title>Reviews & Ratings 2025 - Prostay</title>
                <meta name="description" content="Read verified Prostay reviews and ratings from hoteliers worldwide. Discover how our modular PMS lifts revenue, reduces admin, and delights guests." />
                <link rel="canonical" href={"https://www.prostay.com" + langPrefix + "/reviews/"} />

                <link rel="alternate" href="https://www.prostay.com/en/reviews/" />
                <link rel="alternate" href="https://www.prostay.com/es/reviews/" />

                <meta property="og:title" content="Reviews & Ratings 2025 - Prostay" />
                <meta property="og:description" content="Read verified Prostay reviews and ratings from hoteliers worldwide. Discover how our modular PMS lifts revenue, reduces admin, and delights guests." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={"https://www.prostay.com" + langPrefix + "/reviews/"} />
                <meta property="og:image" content='https://prostay.com/images/ogImage.png' />

                <meta property="og:site_name" content="Prostay" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Reviews & Ratings 2025 - Prostay" />
                <meta name="twitter:description" content="Read verified Prostay reviews and ratings from hoteliers worldwide. Discover how our modular PMS lifts revenue, reduces admin, and delights guests." />
                <meta name="twitter:image" content='https://prostay.com/images/ogImage.png' />
                <meta name="twitter:site" content="@prostaypms" />
                <meta name="twitter:creator" content="@prostaypms" />
            </Helmet>
            <div className='prostay-review'>
                <div className='prostay-review-header' style={{ backgroundImage: 'url(/images/hero-background.png)' }}>
                    <div className='page-content d-flex align-items-center'>
                        <div className='col-6 d-flex flex-column'>
                            <h1>{t('Discover Prostay reviews, ratings, and more.')}</h1>
                            <p className='body-large'>
                                {t('Trusted insights from real hoteliers on how Prostay elevates operations, boosts revenue, and delights guests worldwide.')}
                            </p>
                        </div>
                        <div className='col img-wrapper'>
                            <img src='/images/prostay-review-header.svg' alt={"Prostay Dashboard"} />
                        </div>
                    </div>
                </div>
                <h2 className='d-flex justify-content-center mt-2 py-xl-5 py-3'>
                    {t('Prostay Hotel Management Software Reviews')}
                </h2>
                <div className='d-flex justify-content-center flex-column flex-xl-row page-content gap-phone-size' style={{ margin: '0 auto' }}>
                    <div className='d-flex flex-column align-items-center white-background-fix-width w-100'>
                        <img src='/images/review-portrait-1.svg' alt={"Review Portrait"} style={{ width: '100px' }} />
                        <h6 className='mt-3'>Kratai Katie</h6>
                        <small>{t('Owner')}</small>
                        <small>
                            {t('Phayamas Private Beach Resort & Island Brew / Koh Phayam, Thailand')}
                        </small>
                    </div>
                    <div className='d-flex flex-column max-width-phone'>
                        <h3>
                            {t(`Prostay's automation features have greatly improved our resort.`)}
                        </h3>
                        <div className='custom-fonts'>
                            <div className='py-2 py-xl-4' style={{ marginLeft: '20px' }}>
                                <h1>“</h1>
                                <p style={{ textIndent: "20px" }}>
                                    {t('We’ve struggled navigating through several PMS before we found Prostay. With prompt assistance during onboarding and a smooth staff training, we were up and running faster than we expected. Now, Prostay saves us time through the many automations it provides while we enjoy focusing more on the guest experience.')}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='d-flex justify-content-center flex-column-reverse flex-xl-row page-content pt-xl-5 my-3 my-sm-5 gap-phone-size' style={{ margin: '0 auto' }}>
                    <div className='d-flex flex-column max-width-phone'>
                        <h3>
                            {t('Productivity increased, bottlenecks decreased, staff satisfaction is at all time high since using Prostay.')}
                        </h3>
                        <div className='custom-fonts'>
                            <div className='py-2 py-xl-4' style={{ marginLeft: '20px' }}>
                                <h1>“</h1>
                                <p style={{ textIndent: "20px" }}>
                                    {t('Great results come from great products. Our overall productivity in the resort has increased while reducing bottlenecks through simple implementation of the Prostay features. As our staff now trust the data, the confidence has brought a great sense of relief and satisfaction with direct positive impact on the guest.')}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className='d-flex flex-column align-items-center white-background-fix-width w-100'>
                        <img src='/images/review-portrait-2.svg' alt={"Review Portrait"} style={{ width: '100px' }} />
                        <h6 className='mt-3'>Eve Tsk</h6>
                        <small>{t('General Manager')}</small>
                        <small>
                            {t('A.Z Sunrise Resort & Fitness Club / Phuket, Thailand')}
                        </small>
                    </div>
                </div>
                <div className='padding-inline-smaller-screen'>
                    <div className='d-flex justify-content-center flex-column flex-xl-row gap-3 custom-padding' style={{ backgroundImage: 'url(/images/background-prostay-review.png)', maxWidth: '1200px', margin: '0 auto', borderRadius: '8px', backgroundSize: 'cover' }}>
                        <div className='d-flex align-items-start'>
                            <img src='/images/Group.svg' alt={"Group"} />
                        </div>
                        <div className='d-flex flex-column black-background'>
                            <p>
                                {t('As our island property was growing, we understood that the current management system will not not provide us with the right long term solution. That’s when we shifted to Prostay and it didn’t fail to deliver exactly what it promised: easy to read and always up to date reports, minimal staff training, business automation tools to solve repetitive tasks, and most importantly for us, an on-premise off-line property management solution.')}
                            </p>
                            <div className='d-flex mt-4 gap-3'>
                                <img src='/images/review-portrait-3.svg' alt={"Review Portrait"} style={{ width: '40px' }} />
                                <div className='d-flex flex-column'>
                                    <h6>
                                        Nia Aldini
                                    </h6>
                                    <p style={{ color: '#C1C4CD' }}>
                                        {t('Executive Operations, Komodo Resort / Labuan Bajo, Indonesia')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='d-flex flex-column justify-content-center space-between' style={{ margin: '0 auto', maxWidth: '1100px' }}>
                    <h3 className='d-flex justify-content-center'>
                        {t('More reviews from hospitality properties just like yours')}
                    </h3>
                    <div className='d-flex flex-column flex-xl-row mt-xl-4 mt-2 gap-4'>
                        <div className='d-flex flex-row flex-xl-column justify-content-center align-items-center white-background px-2 px-xl-4 user-container'>
                            <img className='mx-2 mx-sm-4' src='/images/review-portrait-4.svg' alt={"Review Portrait"} style={{ width: '100px' }} />
                            <div className='d-flex justify-content-start justify-content-xl-center flex-column py-4 py-xl-0'>
                                <p className='mt-3 text-align-phone'>
                                    {t('Our Airbnb business needed a management system because were getting swamped in excel files and basic calendars. Prostay gave us the right price and exactly what we needed, nothing more nothing less.')}
                                </p>
                                <p className='custom-p text-align-phone'>
                                    Yang Doo-Hyuk
                                </p>
                                <small className='mt-1 text-align-phone'>
                                    {t('Co-founder, DH Corporation / Osaka, Japan')}
                                </small>
                            </div>
                        </div>
                        <div className='d-flex flex-column gap-4'>
                            <div className='d-flex white-background p-2'>
                                <img className='mx-2 mx-sm-4' src='/images/review-portrait-5.svg' alt={"Review Portrait"} style={{ width: '100px' }} />
                                <div className='py-4 me-sm-5'>
                                    <p>
                                        {t('We were using a free and simple management software for our property but after we started considering adding some more rooms, we realized that we need something more professional to help us understand our business and finance. Prostay helped us while not breaking the bank for a small property like us.')}
                                    </p>
                                    <p className='custom-p'>
                                        An Na
                                    </p>
                                    <small className='mt-1'>
                                        {t('Owner, A&D Holiday Inn / Li Jiang, China')}
                                    </small>
                                </div>
                            </div>
                            <div className='d-flex white-background p-2'>
                                <img className='mx-2 mx-sm-4' src='/images/review-portrait-6.svg' alt={"Review Portrait"} style={{ width: '100px' }} />
                                <div className='py-4 me-sm-5'>
                                    <p>
                                        {t('The Prostay PMS website stands out with its eye-catching design and excellent responsiveness. It includes valuable content such as case studies and client testimonials, giving a clear picture of what they can achieve.')}
                                    </p>
                                    <p className='custom-p'>
                                        Francisco Peña
                                    </p>
                                    <small className='mt-1'>
                                        {t('Nauté Hospitality / La Paz, Mexico')}
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <WhyChooseOurPms
                    headerTitle="Take Control of your Business Today!"
                    headerDescription="Cutting-edge Property Management System designed to revolutionize the way hotels, and resorts from boutique to large-scale, operate and serve their guests."
                    sectionTitle="Why Choose Our PMS?"
                    sectionDescription="Our platform is the preferred choice for hotels, hostels, vacation rentals, and alternative accommodations across the globe. Experience the difference with a PMS designed for growth, efficiency, and guest satisfaction."
                    cards={[
                        { title: t("Where do Prostay reviews come from?"), description: t("We aggregate ratings from G2, Capterra, HotelTechReport, and verified in-app surveys sent to paying customers after 60 days of use.") },
                        { title: t("What is Prostay?"), description: t("Prostay is a modular property-management ecosystem built for hotels, resorts, and vacation rentals. It combines a cloud-based PMS, channel manager, booking engine, point-of-sale system, and AI-powered guest messaging into one platform. Hoteliers can choose the modules they need, work online or offline, and sync data across desktop, tablet, and mobile apps—streamlining operations, boosting revenue, and elevating the guest experience.") },
                        { title: t("Where is Prostay headquarters?"), description: t("Prostay is headquartered in Hong Kong, serving as our legal and operational base. However, our team works remotely across multiple time zones—from Tokyo to Bucharest to Toronto—allowing us to support hotels worldwide around the clock.") },
                        { title: t("How much does Prostay cost?"), description: t("Prostay uses a tiered, modular pricing model. You start with the Core PMS plan and then add modules—Channel Manager, Booking Engine, POS, AI Guest Messaging, and more—à-la-carte. Monthly fees scale with property size (number of rooms/outlets) and the modules you activate, so you only pay for the functionality you need. For a custom quote, contact our Sales team.") },
                        { title: t("Does Prostay have a payment-processing system?"), description: t("Yes. The Prostay Payments module lets you accept credit cards, digital wallets, and OTA virtual cards directly within the PMS and POS. It supports automated payment links, tokenized card-on-file storage, and PCI-compliant reconciliation that syncs to your folios and accounting exports—eliminating the need for third-party terminals and manual matching.") }

                    ]}
                />
            </div>
        </div>
    )
}

export default ProstayReview;